import { createCookie, readCookie } from '../utilities/cookies';

const $window = $(window);

const handleSubscribePopup = () => {
  const $subscribePopup = $('.js-subscribe-popup');
  const $cookiePopup = $('.cookies');

  if (readCookie('subscribePopup') || $subscribePopup.length === 0) {
    return;
  }

  if ($cookiePopup.length > 0 && $cookiePopup.hasClass('is-visible')) {
    const subscribePopupBottomPosition = $cookiePopup.outerHeight() + parseInt($cookiePopup.css('bottom'));

    $subscribePopup.css('bottom', subscribePopupBottomPosition);

    setTimeout(function() {
      $subscribePopup.addClass('is-visible');
    }, 400);
  } else {
    if ($(window).innerWidth() <= 767) {
      $subscribePopup.css('bottom', '-10px');
    }

    $subscribePopup.addClass('is-visible');
  }
}

/**
 * Close Popup
 */
$(document).on('click', '.js-close-subscribe-popup', function(event) {
  const $this = $(this);
  const $parent = $this.closest('.js-subscribe-popup');

  $parent.removeClass('is-visible');

  if (Shopify.designMode) {
    $parent.removeClass('subscribe-popup--admin-panel');
  }

  if (! Shopify.designMode) {
    createCookie('subscribePopup', 'true', 1);
  }

  event.preventDefault();
});

$window.on('load', function() {
  handleSubscribePopup();
});
